import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { galleryImageAt } from '../data/siteGallery';

const IndustryCard = ({ industry }) => {
  const Icon = industry.icon;

  return (
    <div className="group rounded-large overflow-hidden border border-neutral-200 bg-white shadow-custom transition-all hover:border-brand-300 hover:shadow-custom-hover hover-lift">
      <div className="relative h-56 overflow-hidden">
        <img
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
          src={galleryImageAt(industry.imageIndex)}
          alt={industry.imageAlt}
        />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-brand-950/75 via-brand-950/25 to-transparent" />
        <div className="absolute bottom-4 left-4 right-4">
          <div className="mb-2 flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-small bg-brand-700">
              <Icon className="h-6 w-6 text-white" strokeWidth={2} />
            </div>
            <h3 className="font-heading text-xl font-bold text-white">{industry.title}</h3>
          </div>
        </div>
      </div>
      <div className="p-6">
        <p className="mb-4 text-sm leading-relaxed text-neutral-600">{industry.description}</p>
        <ul className="mb-4 space-y-2">
          {industry.features.map((feature) => (
            <li key={feature} className="flex items-start text-sm text-neutral-700">
              <Check className="mr-2 mt-0.5 h-4 w-4 shrink-0 text-brand-900" strokeWidth={2.5} />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        <Link
          to="/products"
          className="inline-flex items-center text-sm font-medium text-brand-900 transition-all hover:text-brand-800 group-hover:gap-2"
        >
          View solutions
          <ArrowRight className="ml-1 h-4 w-4" />
        </Link>
      </div>
    </div>
  );
};

export default IndustryCard;
